import { render, staticRenderFns } from "./UploadVideoForm.vue?vue&type=template&id=451eca99"
import script from "./UploadVideoForm.vue?vue&type=script&lang=js"
export * from "./UploadVideoForm.vue?vue&type=script&lang=js"
import style0 from "./UploadVideoForm.vue?vue&type=style&index=0&id=451eca99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports